import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import {
  getAssetDetailById,
  getAssetFundDetailById,
  getAssetFundsListItems,
} from "../../../../redux/Case/assetSlice";
import { getCaseCategoryByCaseType } from "../../../../utils";
import { Label, Toaster } from "@fluentui/react-components";
import CaseNavList from "../CaseNavList";
import CaseForm from "../CaseForm";
import CaseList from "../CaseList";
import ContentLoader from "../../../../components/Loader/ContentLoader";
import ModalDialog from "../../../../components/ModalDialog";
import { makeStyles, tokens } from "@fluentui/react-components";
import CaseDetailDrawer from "../CaseDetailDrawer";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import NoDataFound from "../../../../components/NoDataFound/noDataFound";

const useStyles = makeStyles({});

const AssetFunds = ({ tab = "fund" }: { tab?: string }) => {
  const navigate = useNavigate();
  const { clientId, action, caseId, subItemId } = useParams();
  const styles = useStyles();
  const dispatch: AppDispatch = useDispatch();
  const assets = useSelector((state: RootState) => state.assets);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);
  const [caseType, setCaseType] = useState<string>("");
  const [activeTab, setActiveTab] = useState<string>(tab);
  const [isOpen, setIsOpen] = useState(false);
  const { showToast, toasterId } = useToastMessage();
  const [currentRecord, setCurrentRecord] = useState(1);

  const handleDetailPopup = (action: boolean) => {
    setIsOpen(action);
  };
  useEffect(() => {
    if (caseId && clientId) {
      dispatch(getAssetDetailById({ id: caseId, customerId: clientId }));
      dispatch(getAssetFundsListItems({ id: caseId, customerId: clientId }));
    }
  }, [caseId, clientId, dispatch]);

  useEffect(() => {
    if (assets?.activeItem?.case_type) {
      setCaseType(getCaseCategoryByCaseType(assets.activeItem.case_type));
    }
  }, [assets?.activeItem]);

  const fundId = subItemId || assets?.funds?.listItems[0]?.fund_id;

  useEffect(() => {
    if (!caseId || !fundId) return;
    if (action === "view") {
      navigate(
        `/clients/${clientId}/assets/${caseId}/funds/${fundId}/fund/view`
      );
    } else if (action === "add") {
      navigate(`/clients/${clientId}/assets/${caseId}/fund/add`);
    } else if (action === "edit") {
      navigate(
        `/clients/${clientId}/assets/${caseId}/funds/${fundId}/fund/edit`
      );
    } else {
      navigate(
        `/clients/${clientId}/assets/${caseId}/funds/${fundId}/fund/view`
      );
    }
  }, [clientId, caseId, fundId, action, assets.actions.listItems, navigate]);

  useEffect(() => {
    if (subItemId) {
      dispatch(getAssetFundDetailById(subItemId));
    }
  }, [subItemId, dispatch, assets.funds.listItems]);

  return (
    <div>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <CaseNavList
        subItem="funds"
        section="assets"
        tab={activeTab}
        caseType={caseType}
        caseDetail={assets?.funds?.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <div className="case_container_flex">
        <CaseForm
          mode={action || ""}
          section="assets"
          caseType={caseType}
          caseDetail={assets?.funds?.activeItem}
          caseItemList={assets?.funds?.listItems}
          tab={activeTab}
          subItem="funds"
          fundValue={assets?.funds?.totalFund}
          notify={showToast}
          currentRecord={currentRecord}
          setCurrentRecord={setCurrentRecord}
        />
        <div>
          {assets?.funds?.loading ? (
            <ContentLoader />
          ) : assets?.funds?.listItems?.length > 0 ? (
            <CaseList
              module="funds"
              data={assets.funds.listItems}
              activeItem={assets.funds.activeItem}
              section="assets"
              activeTab={activeTab}
              currentRecord={currentRecord}
              setCurrentRecord={setCurrentRecord}
            />
          ) : (
            !action && <NoDataFound />
          )}
        </div>
      </div>
      <CaseDetailDrawer
        isOpen={isOpen}
        caseDetail={assets?.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <ModalDialog options={dialogModalOptions} />
    </div>
  );
};

export default AssetFunds;
